import React from "react";
import "../css/DownloadApp.css";

// Import your left and right side image assets
import leftPhoneImg from "../../images/download-App.png";
import rightPhoneImg from "../../images/choosebgraw-03.png";

function DownloadApp() {
  return (
    <section className="crest-download-section">
      <div className="container">
        <div className="row align-items-center">
          
          {/* Left Part: Overlapping Image */}
          <div className="col-lg-3 col-md-4 d-none d-md-block text-center position-relative">
            <div className="crest-dl-img-wrapper left-overlap">
              <img src={leftPhoneImg} alt="Crestest Mobile App Left" className="img-fluid" />
            </div>
          </div>

          {/* Center Part: Text & Google Play Button */}
          <div className="col-lg-6 col-md-8 col-12 text-center crest-dl-center-content">
            <span className="crest-dl-subtitle">Download App</span>
            <h2 className="crest-dl-heading">Download app for your courses</h2>
            <p className="crest-dl-subtext">All courses and facilities on the go!</p>
            
            <div className="crest-dl-btn-wrapper">
              <a
                href="https://play.google.com/store/apps/details?id=com.schemaphic.crestest&pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
                className="crest-google-play-btn"
                title="Get it on Google Play"
              >
                <svg className="play-store-icon" viewBox="0 0 512 512" width="24" height="24">
                  <path fill="#fbb116" d="M325.3 234.3L104.2 113.8c-4.2-2.3-9.1-1.3-12.2 2.3-3.1 3.6-3.8 8.7-1.7 13l138.8 138.8-138.8 138.8c-2.1 4.3-1.4 9.4 1.7 13 3.1 3.6 8 4.6 12.2 2.3l221.1-120.5c5.3-2.9 8.7-8.5 8.7-14.6s-3.4-11.7-8.7-14.6z"/>
                  <path fill="#207AB4" d="M92 116.1v279.8c0 5 2.7 9.6 7 12 4.3 2.4 9.6 2.1 13.6-.7l221.1-120.5L112.7 115.4c-4-2.8-9.3-3.1-13.6-.7-4.3 2.4-7 7-7 1.4z"/>
                  <path fill="#57BDB9" d="M325.3 277.7L104.2 398.2c4.2 2.3 9.1 1.3 12.2-2.3l138.8-138.8L116.4 118.3c-2.1-4.3-1.4-9.4-1.7-13-3.1-3.6-8-4.6-12.2-2.3L325.3 277.7z"/>
                  <path fill="#FBBB1B" d="M325.3 234.3L112.7 115.4c-4-2.8-9.3-3.1-13.6-.7-4.3 2.4-7 7-7 1.4v279.8c0 5 2.7 9.6 7 12 4.3 2.4 9.6 2.1 13.6-.7l212.6-118.9z"/>
                </svg>
                <span>
                  <small>GET IT ON</small>
                  <strong>Google Play</strong>
                </span>
              </a>
            </div>
          </div>

          {/* Right Part: Overlapping Image */}
          <div className="col-lg-3 col-md-4 d-none d-md-block text-center position-relative">
            <div className="crest-dl-img-wrapper right-overlap">
              <img src={rightPhoneImg} alt="Crestest Mobile App Right" className="img-fluid" />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default DownloadApp;